module.exports = __webpack_public_path__ + "img/title-bg.3d71b13e.png";